import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export async function createBooking(data) {
  const res = await api.post("/bookings", data);
  return res.data;
}

export async function submitReview(data) {
  const res = await api.post("/reviews", data);
  return res.data;
}

export async function fetchApprovedReviews() {
  const res = await api.get("/reviews");
  return res.data;
}
